import useFetchPermissions from "./api/customers/useFetchPermissions";
import { CONTRACT, ESIGN, ORDERS, USER_MANAGEMENT } from "util/featureFlags";

type PermissionFlag = string | ESIGN | ORDERS | USER_MANAGEMENT | CONTRACT;

const usePermission = (permissionFlag: PermissionFlag): boolean => {
  const { data: permissions } = useFetchPermissions();
  return permissions?.[permissionFlag] ?? false;
};

export default usePermission;
